<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div
  [class.overflow-style]="freezeHeader"
  [style.max-height]="freezeHeader ? rowsMaxHeight : 'none'"
  class="version-2"
>
  <table
    class="table"
    [class.table-striped]="striped"
    [class.selectable]="selectable"
  >
    <thead [class.sticky-header]="freezeHeader">
      <tr>
        <th
          *ngFor="let column of columns; trackBy: trackByColumnProp"
          scope="col"
          class="table-head-styles"
          [style.width]="column.columnWidth"
        >
          <div [style]="column.style">
            <div [class.sort-icon-reveal-on-hover]="activeSortColumn && activeSortColumn !== column.prop">
              {{ column.name }}
              <ng-container *ngIf="column.subtext">
                <div>
                  {{ column.subtext }}
                </div>
              </ng-container>
              <ng-container *ngIf="column.headerFaIcon">
                <lfx-hover-trigger
                  theme="dark"
                  [openDelay]="200"
                  [closeDelay]="100"
                >
                  <i
                    *ngIf="!column.headerFaIcon.svgAsset"
                    [class]="'header-fa-icon ' + column.headerFaIcon.icon"
                    [attr.aria-label]="column.headerFaIcon.hoverText || column.headerFaIcon.hoverContent"
                    role="img"
                  ></i>
                  <img
                    *ngIf="column.headerFaIcon.svgAsset"
                    [src]="column.headerFaIcon.svgAsset"
                    class="header-fa-icon"
                    [attr.aria-label]="column.headerFaIcon.hoverText || column.headerFaIcon.hoverContent"
                    role="img"
                  />
                  <div slot="popover-content" class="header-tooltip-content">
                    <span [innerHTML]="getSanitizedHeaderFaIconHoverContent(column)"></span>
                  </div>
                </lfx-hover-trigger>
              </ng-container>
              <ng-container
                *ngIf="(column.sortable && column.sortDir) || column.infoIcon"
              >
                <i
                  *ngIf="column.sortDir === 'asc'"
                  (click)="column.sortDir = toggleSortOrder(column)"
                  class="far fa-arrow-up cursor-pointer sort-icon"
                ></i>
                <i
                  *ngIf="column.sortDir === 'desc'"
                  (click)="column.sortDir = toggleSortOrder(column)"
                  class="far fa-arrow-down cursor-pointer sort-icon"
                ></i>
                <i
                  *ngIf="column.infoIcon && column.infoIcon.action === 'click'"
                  class="fal fa-info-circle lf-grey-500 cursor-pointer"
                  (click)="infoIconClickEmitter.emit(column)"
                ></i>
                <ng-container *ngIf="column.infoIcon && column.infoIcon.action === 'hover'">
                  <lfx-hover-trigger
                    theme="dark"
                    popoverClass="table-info-popover"
                    [openDelay]="200"
                    [closeDelay]="100"
                  >
                    <i class="fal fa-info-circle lf-grey-500"></i>
                    <div slot="popover-content">
                      <span *ngIf="column.infoIcon.useInnerHtmlForHoverText" [innerHTML]="column.infoIcon.hoverText"></span>
                      <span *ngIf="!column.infoIcon.useInnerHtmlForHoverText">{{ column.infoIcon.hoverText }}</span>
                    </div>
                  </lfx-hover-trigger>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="showGroupedRows">
        <ng-container *ngFor="let group of groupedData; trackBy: trackByGroupLabel">
          <div (click)="toggleAccordion(group)" class="group-styles">
            <i
              *ngIf="group.expanded"
              class="fas fa-caret-down caret-styles"
            ></i>
            <i
              *ngIf="!group.expanded"
              class="fas fa-caret-right caret-styles"
            ></i>
            <span
              class="grouped-rows-label"
              [class.grouped-rows-label-expanded]="group.expanded"
              >{{ group.label }} ({{ group.count ?? group.data?.length }})</span
            >
          </div>
          <ng-container *ngIf="group.expanded">
            <tr
              *ngFor="let rowData of group.data; let index = index; trackBy: trackByRowId"
              class="table-row-styles-2"
              (click)="handleRowClick(rowData, index)"
              [class.selected-row]="selectedIndex === index"
            >
              <td
                *ngFor="let column of columns; let first = first; trackBy: trackByColumnProp"
                class="table-cell-styles"
              >
                <div class="cell-container" [style]="column.style">
                  <ng-container *ngIf="column.template">
                    <ng-container
                      *ngTemplateOutlet="
                        column.template;
                        context: { row: rowData, column: column }
                      "
                    ></ng-container>
                  </ng-container>
                  <ng-container *ngIf="!column.template">
                    <div
                      [class.first]="first"
                      [class.lf-link-v2]="
                        column.clickableText ||
                        rowData[column.prop].clickableText
                      "
                      [class.italic-text]="rowData[column.prop].italic"
                      [style]="column.dataStyle"
                      (click)="
                        (column.clickableText ||
                          rowData[column.prop].clickableText) &&
                          handleColumnTextClick({ row: rowData, column })
                      "[attr.title]="column.textEllipsis ? rowData[column.prop].text : null"
                    >
                      <ng-container
                        *ngIf="column.linkableText && rowData[column.prop].url"
                      >
                        <a
                          attr.href="{{ rowData[column.prop].url | urlFormat }}"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="lf-link-v2"
                        >
                          <span>{{
                          column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text }}</span>
                        </a>
                      </ng-container>
                      <ng-container *ngIf="!column.linkableText">
                        <!-- Clickable HTML content -->
                        <div *ngIf="(column.clickableText || rowData[column.prop].clickableText) && rowData[column.prop].isHtml"
                             [class.lf-link-v2]="column.clickableText || rowData[column.prop].clickableText"
                             (click)="(column.clickableText || rowData[column.prop].clickableText) && handleColumnTextClick({ row: rowData, column })"
                             [innerHTML]="column.textEllipsis
                               ? (rowData[column.prop].text | ellipsis: column.textEllipsis)
                               : rowData[column.prop].text">
                        </div>
                        <!-- Clickable plain text content -->
                        <div *ngIf="(column.clickableText || rowData[column.prop].clickableText) && !rowData[column.prop].isHtml"
                             [class.lf-link-v2]="column.clickableText || rowData[column.prop].clickableText"
                             (click)="(column.clickableText || rowData[column.prop].clickableText) && handleColumnTextClick({ row: rowData, column })">
                          {{ column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text }}
                        </div>
                        <!-- Non-clickable HTML content -->
                        <div *ngIf="!(column.clickableText || rowData[column.prop].clickableText) && rowData[column.prop].isHtml"
                             [innerHTML]="column.textEllipsis
                               ? (rowData[column.prop].text | ellipsis: column.textEllipsis)
                               : rowData[column.prop].text">
                        </div>
                        <!-- Non-clickable plain text content -->
                        <ng-container *ngIf="!(column.clickableText || rowData[column.prop].clickableText) && !rowData[column.prop].isHtml">
                          {{ column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text }}
                        </ng-container>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="rowData[column.prop].subtext"
                      class="subtext"
                      [style]="rowData[column.prop].subtextStyle"
                    >
                      {{ rowData[column.prop].subtext }}
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr *ngIf="groupEndContentTemplate">
              <td [attr.colspan]="columns.length">
                <ng-container *ngTemplateOutlet="groupEndContentTemplate; context: {$implicit: group}"></ng-container>
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="(!groupedData || !groupedData.length) && emptyDataMessage">
          <tr>
            <td [attr.colspan]="columns.length" class="lf-empty-data-message">
              {{ emptyDataMessage }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!showGroupedRows">
        <ng-container *ngIf="displayedData && displayedData.length">
          <tr
            *ngFor="let rowData of displayedData; let index = index; trackBy: trackByRowId"
            class="table-row-styles-2"
            (click)="handleRowClick(rowData, index)"
            [class.selected-row]="selectedIndex === index"
          >
            <td
              *ngFor="let column of columns; let first = first; trackBy: trackByColumnProp"
              class="table-cell-styles"
            >
              <div class="cell-container" [style]="column.style">
                <ng-container *ngIf="column.template">
                  <ng-container
                    *ngTemplateOutlet="
                      column.template;
                      context: { row: rowData, column: column }
                    "
                  ></ng-container>
                </ng-container>
                <ng-container *ngIf="!column.template">
                  <div
                    [class.first]="first"
                    [class.italic-text]="rowData[column.prop].italic"
                    [style]="column.dataStyle"
                    [attr.title]="
                      column.textEllipsis ? rowData[column.prop].text : null
                    "
                  >
                    <!-- Clickable text:  a clickable text to perform an action within the application eg open a flyout -->
                    <div
                      *ngIf="
                        column.clickableText ||
                        rowData[column.prop].clickableText
                      "
                      [class.lf-link-v2]="
                        column.clickableText ||
                        rowData[column.prop].clickableText
                      "
                      (click)="
                        (column.clickableText ||
                          rowData[column.prop].clickableText) &&
                          handleColumnTextClick({ row: rowData, column })
                      "
                    >
                      <!-- HTML content for clickable text -->
                      <span *ngIf="rowData[column.prop].isHtml"
                           [innerHTML]="column.textEllipsis
                             ? (rowData[column.prop].text | ellipsis: column.textEllipsis)
                             : rowData[column.prop].text">
                      </span>
                      <!-- Plain text content for clickable text -->
                      <span *ngIf="!rowData[column.prop].isHtml">
                        {{
                          column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text
                        }}
                      </span>
                    </div>
                    <!-- Linkable text:  a link that opens in a new tab -->
                    <div
                      *ngIf="column.linkableText && rowData[column.prop].url"
                    >
                      <a
                        attr.href="{{ rowData[column.prop].url | urlFormat }}"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="lf-link-v2"
                      >
                        <span>{{
                          column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text
                        }}</span>
                      </a>
                    </div>
                    <!-- Ordinary text -->
                    <ng-container *ngIf="!column.linkableText && !(column.clickableText || rowData[column.prop].clickableText)">
                      <!-- HTML content -->
                      <div *ngIf="rowData[column.prop].isHtml"
                           [innerHTML]="column.textEllipsis
                             ? (rowData[column.prop].text | ellipsis: column.textEllipsis)
                             : rowData[column.prop].text">
                      </div>
                      <!-- Plain text content -->
                      <ng-container *ngIf="!rowData[column.prop].isHtml">
                        {{
                          column.textEllipsis
                            ? (rowData[column.prop].text
                              | ellipsis: column.textEllipsis)
                            : rowData[column.prop].text
                        }}
                      </ng-container>
                    </ng-container>
                  </div>
                  <div
                    *ngIf="rowData[column.prop].subtext"
                    class="subtext"
                    [style]="rowData[column.prop].subtextStyle"
                  >
                    {{ rowData[column.prop].subtext }}
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="(!data || !data.length) && emptyDataMessage">
          <tr>
            <td [attr.colspan]="columns.length" class="lf-empty-data-message">
              {{ emptyDataMessage }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>

  <!-- Table footer with pagination info and load more button -->
  <div class="table-footer mt-3" *ngIf="useTablePagination && !showGroupedRows && data && data.length > 0">
    <div class="d-flex justify-content-between align-items-center">
      <!-- Total rows count -->
      <div class="text-muted small">
        Showing {{ displayedData.length }} of {{ totalRows }} row{{ totalRows !== 1 ? 's' : '' }}
      </div>

      <!-- Show all button -->
      <div *ngIf="hasMoreRows">
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          (click)="showAll()"
          style="text-decoration: none;"
        >
          Show all
        </button>
      </div>
    </div>
  </div>

  <ng-content select="[showMore]"></ng-content>
</div>
